import { supabase } from '../supabaseClient';
import { enrichEventWithImages } from '../../utils/signedUrls';

/**
 * Busca todos os eventos.
 * Permite filtrar, selecionar colunas específicas e ordernar.
 */
export async function getEvents(options = {}) {
  const { columns = '*', filters = {}, orderBy = { column: 'id', ascending: false } } = options;
  
  let query = supabase.from('events').select(columns);

  if (filters.municipio && filters.municipio !== 'Todos') {
    query = query.contains('municipios', [filters.municipio]);
  }
  
  if (filters.categoria && filters.categoria !== 'Todas') {
    query = query.contains('categorias', [filters.categoria]);
  }

  if (filters.searchTerm) {
    query = query.ilike('nome', `%${filters.searchTerm}%`);
  }

  query = query.order(orderBy.column, { ascending: orderBy.ascending });

  const { data, error } = await query;
  
  if (error) {
    console.error('Erro ao buscar eventos:', error);
    throw error;
  }
  return (data || []).map(enrichEventWithImages);
}

/**
 * Busca um evento específico por ID
 */
export async function getEventById(id) {
  const { data, error } = await supabase
    .from('events')
    .select('*')
    .eq('id', id)
    .single();

  if (error) {
    console.error(`Erro ao buscar evento ${id}:`, error);
    throw error;
  }
  return enrichEventWithImages(data);
}

/**
 * Cria um novo evento
 */
export async function createEvent(eventData) {
  const { data, error } = await supabase
    .from('events')
    .insert([eventData])
    .select();

  if (error) {
    console.error('Erro ao criar evento:', error);
    throw error;
  }
  return data;
}

/**
 * Atualiza um evento existente
 */
export async function updateEvent(id, eventData) {
  const { data, error } = await supabase
    .from('events')
    .update(eventData)
    .eq('id', id)
    .select();

  if (error) {
    console.error(`Erro ao atualizar evento ${id}:`, error);
    throw error;
  }
  return data;
}

/**
 * Deleta um evento
 */
export async function deleteEvent(id) {
  const { data, error } = await supabase
    .from('events')
    .delete()
    .eq('id', id);

  if (error) {
    console.error(`Erro ao deletar evento ${id}:`, error);
    throw error;
  }
  return data;
}

/**
 * Salva avaliação (rating) de um evento
 */
export async function submitEventRating(eventId, rating, userFingerprint) {
  const { data: existingVote } = await supabase
    .from('event_ratings')
    .select('id')
    .eq('event_id', eventId)
    .eq('fingerprint', userFingerprint)
    .maybeSingle();

  if (existingVote) {
    throw new Error('Você já avaliou este ponto.');
  }

  const event = await getEventById(eventId);
  
  const newRatingCount = (event.rating_count || 0) + 1;
  const newRatingSum = (event.rating_sum || 0) + rating;

  const updatedEventData = await updateEvent(eventId, {
    rating_sum: newRatingSum,
    rating_count: newRatingCount
  });

  await supabase
    .from('event_ratings')
    .insert([{ event_id: eventId, fingerprint: userFingerprint, rating }]);

  return updatedEventData?.[0] || updatedEventData;
}
